import axios from 'axios';
import serviceConfig from "./serviceConfig";
import { getToken } from "./../auth/utils";
import { checkStatusCode } from "./services";
import queryString from "query-string";

const svConfig = { ...serviceConfig };

const loadWithdrawFirst = async () => {
    let config = {
        method: svConfig.method_get,
        url: '/customer/payment-v2/withdraw/channel',
        headers: {
            "Authorization": `${svConfig.headerType} ${getToken()}`,
            "Content-Type": svConfig.contentType
        },
        data: {}
    };

    const dataPromise = await axios(config).then((response) => response.data).catch((e) => e.response.data);
    const { code, result } = dataPromise;

    if (checkStatusCode(code)) {
        return {
            result: result,
            code: code
        };
    }
}

const confirmWithdraw = async (data, requestPath = "/customer/payment/withdraw/channel-v2") => {
    const {
        amount,
        bankId,
        channel,
        channelId
    } = data;

    let myJson = {
        amount,
        bankId,
        channel,
        channelId
    };

    let config = {
        method: svConfig.method_post,
        url: requestPath,
        headers: {
            "Authorization": `${svConfig.headerType} ${getToken()}`,
            "Content-Type": svConfig.contentType
        },
        data: queryString.stringify(myJson)
    };

    const dataPromise = await axios(config).then((response) => response.data).catch((e) => e.response.data);
    const { code, result } = dataPromise;

    if (checkStatusCode(code)) {
        return {
            result: result,
            code: code
        };
    }
}

const checkWithdraw = async (depositId) => {
    let myJson = {
        "id": depositId
    };

    let config = {
        method: svConfig.method_post,
        url: '/customer/payment/withdraw/check',
        headers: {
            "Authorization": `${svConfig.headerType} ${getToken()}`,
            "Content-Type": svConfig.contentType
        },
        data: queryString.stringify(myJson)
    };

    const dataPromise = await axios(config).then((response) => response.data).catch((e) => e.response.data);
    const { code, result } = dataPromise;

    if (checkStatusCode(code)) {
        return {
            result: result,
            code: code
        };
    }
}

const loadWithdrawRank = async () => {
    let config = {
        method: svConfig.method_get,
        url: `/common/section/withdraw`,
        headers: {
            "Authorization": `${svConfig.headerType} ${getToken()}`,
            "Content-Type": svConfig.contentType
        },
        data: {}
    };

    const dataPromise = await axios(config).then((response) => response.data).catch((e) => e.response.data);
    const { code, result } = dataPromise;

    if (checkStatusCode(code)) {
        if (code === 0) {
            return result;
        }
        else {
            return [];
        }
    }
}

const confirmWithdrawP2P = async (data, requestPath = "/customer/payment-v3/withdraw/submit-p2p") => {
    const {
        amount,
        bankId,
        channel,
        channelId
    } = data;

    let myJson = {
        amount,
        bankId,
        channel,
        channelId
    };

    let config = {
        method: svConfig.method_post,
        url: requestPath,
        headers: {
            "Authorization": `${svConfig.headerType} ${getToken()}`,
            "Content-Type": svConfig.contentType
        },
        data: queryString.stringify(myJson)
    };

    const dataPromise = await axios(config).then((response) => response.data).catch((e) => e.response.data);
    const { code, result } = dataPromise;

    if (checkStatusCode(code)) {
        return {
            result: result,
            code: code
        };
    }
}

// 📍 เพิ่มฟังก์ชันสำหรับยกเลิกถอน P2P โดยเฉพาะ
const cancelWithdrawP2P = async (withdrawId) => {
    let myJson = { "id": withdrawId };

    let config = {
        method: svConfig.method_post,
        url: '/customer/payment-v3/withdraw/cancel-p2p',
        headers: {
            "Authorization": `${svConfig.headerType} ${getToken()}`,
            "Content-Type": svConfig.contentType
        },
        data: queryString.stringify(myJson)
    };

    const dataPromise = await axios(config).then((response) => response.data).catch((e) => e.response.data);
    const { code, result, message } = dataPromise;

    if (checkStatusCode(code)) {
        return {
            result: result,
            code: code,
            message: message
        };
    }
}

export {
    loadWithdrawFirst,
    confirmWithdraw,
    checkWithdraw,
    loadWithdrawRank,
    confirmWithdrawP2P,
    cancelWithdrawP2P // 📍 อย่าลืม export ให้ไฟล์อื่นเรียกใช้ได้
};